export default {
  points: {},
  totalPnts: {},
  pules: {},
};
